module.exports = __webpack_public_path__ + "img/portrait-009.1282368e.jpg";